import { render, staticRenderFns } from "./economics.vue?vue&type=template&id=4bcb75e6&"
import script from "./economics.vue?vue&type=script&lang=js&"
export * from "./economics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports